export default "__VITE_ASSET__0wpQMlMi__"